import { BaseColors, ColorScale } from '@/theme/types'

/**
 * Light theme primary color scale based on #722fa2
 * This is the source of truth for light theme branding
 */
export const primaryLight: ColorScale = {
  50: '#F5EDFA',
  100: '#E8D5F0',
  200: '#D6B8E3',
  300: '#C49BD6',
  400: '#B57DCA',
  500: '#722fa2', // Brand color for light theme - SOURCE OF TRUTH
  600: '#5E2688',
  700: '#4A1E6E',
  800: '#361654',
  900: '#220E3A',
}

/**
 * Dark theme primary color scale based on #9B6BFF
 * This is the source of truth for dark theme branding
 */
export const primaryDark: ColorScale = {
  50: '#F4ECFF',
  100: '#E5D7FF',
  200: '#D2BDFF',
  300: '#BFA3FF',
  400: '#B08CFF',
  500: '#9B6BFF', // Brand color for dark theme - SOURCE OF TRUTH
  600: '#7C4DFF',
  700: '#5E36E6',
  800: '#4528B8',
  900: '#301C8A',
}

export const gray: ColorScale = {
  50: '#F9FAFB',
  100: '#F3F4F6',
  200: '#E5E7EB',
  300: '#D1D5DB',
  400: '#9CA3AF',
  500: '#6B7280',
  600: '#4B5563',
  700: '#374151',
  800: '#1F2937',
  900: '#111827',
}

export const success: ColorScale = {
  50: '#ECFDF5',
  100: '#D1FAE5',
  200: '#A7F3D0',
  300: '#6EE7B7',
  400: '#34D399',
  500: '#10B981',
  600: '#059669',
  700: '#047857',
  800: '#065F46',
  900: '#064E3B',
}

export const error: ColorScale = {
  50: '#FEF2F2',
  100: '#FEE2E2',
  200: '#FECACA',
  300: '#FCA5A5',
  400: '#F87171',
  500: '#EF4444',
  600: '#DC2626',
  700: '#B91C1C',
  800: '#991B1B',
  900: '#7F1D1D',
}

export const warning: ColorScale = {
  50: '#FFFBEB',
  100: '#FEF3C7',
  200: '#FDE68A',
  300: '#FCD34D',
  400: '#FBBF24',
  500: '#F59E0B',
  600: '#D97706',
  700: '#B45309',
  800: '#92400E',
  900: '#78350F',
}

export const info: ColorScale = {
  50: '#EFF6FF',
  100: '#DBEAFE',
  200: '#BFDBFE',
  300: '#93C5FD',
  400: '#60A5FA',
  500: '#3B82F6',
  600: '#2563EB',
  700: '#1D4ED8',
  800: '#1E40AF',
  900: '#1E3A8A',
}

export const baseColors: BaseColors = {
  primary: primaryLight,
  gray,
  success,
  error,
  warning,
  info,
}

